<h2 mat-dialog-title>Porta un amico!</h2>

<mat-dialog-content>
  <p>Inserisci qui i suoi dati. Penseremo noi a contattarlo e ad attivare il suo account!</p>

  <div class="container-fluid p-0">
    <!-- Loading Spinner -->
    <div *ngIf="isLoading" class="d-flex justify-content-center align-items-center py-4">
      <mat-spinner diameter="50"></mat-spinner>
    </div>

    <!-- Form - MOVE THE FORM TAG TO WRAP ALL FORM CONTROLS -->
    <form [formGroup]="referralForm" *ngIf="!isLoading" class="mt-3">
      <!-- Name Field -->
      <mat-form-field appearance="outline" class="w-100 mb-2">
        <mat-label>Nome e Cognome</mat-label> <!-- Added asterisk for required -->
        <input 
          matInput 
          formControlName="name"
          placeholder="Inserisci nome e cognome">
        <mat-icon matSuffix>person</mat-icon>
        <mat-error *ngIf="isFieldInvalid('name')">
          {{ getErrorMessage('name') }}
        </mat-error>
      </mat-form-field>

      <!-- Email Field -->
      <mat-form-field appearance="outline" class="w-100 mb-2">
        <mat-label>Email</mat-label> <!-- Added asterisk for required -->
        <input 
          matInput 
          formControlName="mail"
          placeholder="Inserisci email"
          type="email">
        <mat-icon matSuffix>email</mat-icon>
        <mat-error *ngIf="isFieldInvalid('mail')">
          {{ getErrorMessage('mail') }}
        </mat-error>
      </mat-form-field>

      <!-- Telephone Field -->
      <mat-form-field appearance="outline" class="w-100 mb-2">
        <mat-label>Telefono</mat-label>
        <input 
          matInput 
          formControlName="telephone"
          placeholder="Inserisci telefono"
          type="tel"> <!-- Changed from "telephone" to "tel" -->
        <mat-icon matSuffix>phone</mat-icon>
        <mat-error *ngIf="isFieldInvalid('telephone')">
          {{ getErrorMessage('telephone') }}
        </mat-error>
      </mat-form-field>

      <!-- Date and Is Already Partita IVA Row -->
      <div class="row align-items-center mb-3">
        <!-- <div class="col-6">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Data</mat-label>
            <input 
              matInput 
              [value]="newRequest.date" 
              readonly>
            <mat-icon matSuffix>calendar_today</mat-icon>
          </mat-form-field>
        </div> -->
        <div class="col-12 d-flex align-items-center">
          <mat-checkbox formControlName="is_already_partita_iva" color="primary">
            È già una Partita IVA
          </mat-checkbox>
          <mat-icon 
            class="ms-2" 
            matTooltip="Seleziona se la persona ha già una Partita IVA"
            [matTooltipPosition]="'right'"
            [matTooltipShowDelay]="showDelay.value || 700">
            info
          </mat-icon>
        </div>
      </div>

      <!-- Privacy Checkbox - MOVED INSIDE THE FORM -->
      <div class="mb-3">
        <mat-checkbox 
          formControlName="privacy_1" 
          color="primary"
          [class.text-danger]="isFieldInvalid('privacy_1')">
          <span class="fw-bold">Acconsento al trattamento dei dati personali della persona da me presentata, e dichiaro di aver ricevuto il suo consenso per l'invio dei dati *</span>
        </mat-checkbox>
        <mat-error *ngIf="isFieldInvalid('privacy_1')" class="small">
          Devi accettare il trattamento dei dati per procedere
        </mat-error>
        <small class="text-muted d-block mt-1">
          I dati saranno utilizzati esclusivamente per la gestione della richiesta e per la corretta creazione dell'account.
        </small>
      </div>
    </form> <!-- CLOSE THE FORM TAG HERE -->
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="p-3 border-top">
  <button 
    mat-button 
    (click)="onCancel()"
    [disabled]="isLoading">
    Annulla
  </button>
  
  <button 
    mat-raised-button 
    color="primary"
    (click)="createReferralRequest()"
    [disabled]="isLoading || referralForm.invalid"
    class="ms-2">
    <mat-icon *ngIf="!isLoading" class="me-1">send</mat-icon>
    <mat-spinner *ngIf="isLoading" diameter="20" class="d-inline-block me-2"></mat-spinner>
    {{ isLoading ? 'Invio in corso...' : 'Invia Richiesta' }}
  </button>
</mat-dialog-actions>



